/**
 * Tabela "Macros" da sala (a tabela de macros do módulo embutido do original): um botão
 * para cada macro (da mesa, minhas desta mesa, minhas globais). O botão roda `/nome` no
 * chat principal, pelo mesmo caminho de quem digita.
 */
import { useState } from 'react';
import { useT } from '../../i18n/index.js';
import { useApp } from '../../store.js';
import { Button } from '../../ui/controls.js';
import { MacrosDialog, useRoomMacros } from './MacrosDialog.js';
import { distinctMacros, macroLines, useMyMacros } from './model.js';
import './macros.css';

/** Tipo de dado da tabela de macros embutida (`packages/shared/src/roomTables.ts`). */
export { MACROS_PANEL } from '../../shared.js';

export function MacrosPanel() {
  const t = useT();
  const me = useApp((s) => s.user?.id);
  const roomId = useApp((s) => s.room?.id ?? '');
  const runInChat = useApp((s) => s.runInChat);
  const { macros: roomMacros } = useRoomMacros();
  const mine = useMyMacros(me);
  const [managing, setManaging] = useState(false);

  // a mesma macro em dois lugares: vale a primeira (a mesma ordem e a mesma comparação da busca do chat)
  const [room, ofRoom, global] = distinctMacros(roomMacros, mine.rooms[roomId] ?? [], mine.global);
  const groups = [
    { id: 'room', macros: room! },
    { id: 'mine', macros: ofRoom! },
    { id: 'global', macros: global! },
  ].filter((g) => g.macros.length > 0);

  return (
    <div className="rd-macroPanel">
      <div className="rd-macroPanel__bar">
        <Button variant="secondary" onClick={() => setManaging(true)}>
          {t('macro.manage')}
        </Button>
      </div>
      {groups.length === 0 ? <p className="rd-macroPanel__empty">{t('macro.panel.empty')}</p> : null}
      {groups.map((g) => (
        <section key={g.id} className="rd-macroPanel__group" aria-label={t(`macro.tab.${g.id}`)}>
          <h4>{t(`macro.tab.${g.id}`)}</h4>
          <div className="rd-macroPanel__buttons">
            {g.macros.map((m) => (
              <button key={m.id} type="button" className="rd-macroPanel__btn" title={macroLines(m).join('\n') || t('macro.emptyRun', { name: m.name })} onClick={() => runInChat(`/${m.name}`)}>
                {m.name}
              </button>
            ))}
          </div>
        </section>
      ))}
      {managing ? <MacrosDialog onClose={() => setManaging(false)} /> : null}
    </div>
  );
}
